import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import { omit } from 'ramda'

import Tooltip from '@/app/component/atom/tooltip'
import { LIBRARY_MESSAGE_TYPES } from '@/app/module/campaigns/definitions'
import { Message, ReminderMessage } from '@/app/module/campaigns/types'
import { useGetSnippets } from '@/app/module/user/hooks/use-get-snippets'
import { useSaveSnippet } from '@/app/module/user/hooks/use-save-snippet'

const getTooltipText = (inLibrary: boolean, isIncluded: boolean) => {
  if (inLibrary) {
    return 'Message already added to the library.'
  }

  return isIncluded ? 'Save message to library for later use.' : `This message type can't be saved.`
}

const omitList = ['id', 'changed', 'delta', 'offset']

type LibrarySaveButtonProps = {
  index: number
  message: Message | ReminderMessage
}

export function LibrarySaveButton({ index, message }: LibrarySaveButtonProps) {
  const snippets = useGetSnippets({ category: 'message' })
  const [saveSnippet, saveSnippetResult] = useSaveSnippet()
  const isIncluded = LIBRARY_MESSAGE_TYPES.includes(message.type)
  const disabled = snippets.isFetching || snippets.isLoading || saveSnippetResult.isLoading
  const jsonMessage = JSON.stringify(omit(omitList, message))
  const inLibrary = !!snippets.data?.snippets?.some(
    (s) => s.category === 'message' && jsonMessage === JSON.stringify(omit(omitList, s.snippet)),
  )

  return (
    <Tooltip title={getTooltipText(inLibrary, isIncluded)}>
      <span>
        <IconButton
          id={`save-part-to-library-${index}`}
          disabled={disabled || inLibrary || !isIncluded}
          onClick={() => {
            saveSnippet({
              item: { category: 'message', snippet: message },
            })
          }}
        >
          <Icon>{inLibrary ? 'library_add_check' : 'library_add'}</Icon>
        </IconButton>
      </span>
    </Tooltip>
  )
}
